/**
 * Enum representing a push notification platform
 */
import { InjectionToken } from '../../injection';

export enum PushPlatform {
  Undefined = 'Undefined',
  ADM = 'ADM',
  APNS = 'APNS',
  APNS_SANDBOX = 'APNS_SANDBOX',
  GCM = 'GCM'
}

export const PUSH_PLATFORM: InjectionToken<PushPlatform>
  = new InjectionToken<PushPlatform>('PUSH_PLATFORM');
